<template>
  <div class="container general-section">

    <h1>
      <font-awesome-icon icon="cog"/>
      Inställningar
    </h1>

    <div>
      <property-item v-for="property in properties" :key="property.uuid" :property="property" />
    </div>

    <div class="card card-form">
      <div class="card-body">
        <h2>
          <font-awesome-icon icon="users-cog"/>
          Tillgång till Kontrollpanelen
        </h2>

        <input-control
          label="E-postaddress (inloggning)"
          :readonly="true"
          :value="affiliate.email" />

        <div class="alert alert-warning mb-0">
          För närvarande tillåter vi inte att ändra Kontrollpanel-uppgifter (såsom email eller lösenord) härifrån. Men vi står redo att assistera er och ändra det åt er. Vänligen kontakta oss på <a href="mailto:hej@tecknael.se">hej@tecknael.se</a>, och vi kan ändra er email eller återställa ert lösenord.
        </div>

      </div>
    </div>


  </div>
</template>

<script>

  import {mapState} from 'vuex'
  import InputControl from "../../Partials/Controls/Input"
  import DataValidator from "../../../app/mixins/Validation/DataValidator"
  import PropertyItem from "./Property"

  export default {
    name: "Settings",
    components: {PropertyItem, InputControl},
    mixins: [
      DataValidator()
    ],
    computed: {
      ...mapState({
        affiliate: state => state.auth.affiliate,
        properties: state => state.properties.collection
      })
    },
    mounted(){
      return this.$store.dispatch('properties/collection')
    },
    metaInfo() {
      return {
        title: 'Inställningar'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Settings/Index.vue